<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="批量生成费用"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <div>
            <el-button @click="selects">查询</el-button>
            <el-button @click="listAdd">开始计算</el-button>
            <el-button @click="third">查看进度</el-button>
            <el-button @click="tops">关闭</el-button>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item  label="计费周期">
                <el-date-picker v-model="date.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="date.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item  label="区域">
                <el-select style="margin-left: 10px;" clearable v-model="zones" @change="zonec" placeholder="战区">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item  label="选项收费项">
                <el-button @click="boots(true)">全选</el-button>
                <el-button @click="boots(false)">反选</el-button>
              </el-descriptions-item>
              <el-descriptions-item>
                <div v-if="types == 1" style="color: red;">加载中...</div>
                <div v-if="types == 3" style="color: red;">提交保存中...</div>
              </el-descriptions-item>
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <div v-if="addtype == 1">
            <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="60vh"  @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column label="项目" width="230">
                <template slot-scope="scope">
                   {{scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column prop="sum" label="计算数量" width="100"></el-table-column>
              <el-table-column label="收费项目" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div style="display: flex;flex-wrap: wrap;margin-top: 3px;">
                    <div v-for="(it,index1) in scope.row.chargeitem_name" style="margin-left: 10px;">
                       <el-checkbox v-model="tableData[scope.$index].chargeitem_name[index1].boot">
                        {{it.chargeItem_name}}
                        <!-- {{tableData[scope.$index].chargeitem_name[index1].chargeItem_name}} -->
                       </el-checkbox>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="addtype == 2">
            <el-table ref="multipleTable" :data="dessertsLog" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange1">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="homeName" label="房产"  width="320"></el-table-column>
                <el-table-column label="进度" width="320">
                  <template slot-scope="scope">
                    <el-progress style="width: 300px;" :text-inside="true" :stroke-width="26" :percentage="scope.row.count"></el-progress>
                  </template>
                </el-table-column>
                <el-table-column prop="statue" label="处理结果" width="80"></el-table-column>
                <el-table-column  label="计费周期" width="160">
                  <template slot-scope="scope">
                    {{scope.row.startDate}}-{{scope.row.endDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="end" label="总对象" width="80"></el-table-column>
                <el-table-column prop="number_end" label="总条数" width="80"></el-table-column>
                <el-table-column label="生成条数" width="120">
                  <template slot-scope="scope">
                    {{scope.row.start-scope.row.number}}
                  </template>
                </el-table-column>
                <el-table-column prop="number" label="已存在条数" width="100"></el-table-column>
                <el-table-column prop="name" label="生成人" width="80"></el-table-column>
                <el-table-column prop="date" label="发生时间" width="140"></el-table-column>
              </el-table>
              <div class="pages">
                <Page :total="totallog" :page-size="pagelog" @on-change="changelog"  show-total />
              </div>
            </el-tab-pane>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          totallog:0,
          pagelog:12,
          dessertsLog:[],
          types:2,
          total:0,
          page:1,
          type:1,
          pageSize:20,
          loading_dade:1,
          dialogVisible:false,
          tableData: [],
          order: [],
          money_val:0,
          money:0,
          date:{
            startDate:'',
            endDate:'',
          },
          select:{
            pay:'',
            house:'',
            name:'',
            date:'',
            chargeitem_id:[],
          },
          customer:[],
          dataPay:[],
          xsc_bill_no:'',
          house:[],
          chargeitem:[],
          loading:false,
          pid:'',
          house_name:'',
          zones:'',
          options:[],
          jurisdictionId:'',
          orders:[],
          addtype:1,
          pe:1,
          timer:''
        }
      },
      //事件
      methods: {
        getInvo(){
          this.zone();
          this.dialogVisible = true;
        },
        third(){
          this.addtype = 2;
          this.changelog(1);
          this.emdtime();
          this.times();
        },
        selects(){
          if(this.zones){
            this.getProjectList2();
          }else{
            this.getProjectList();
          }
          this.emdtime();
        },
        tops(){
          this.dialogVisible = false;
          this.emdtime();
        },
        //进度分析
        changelog(e){
          this.pe = e;
          let data = {'page':e,'lists':1,'pid':1};
          this.$myhttp.post('admin/RoutineExpense/orderRoutineLog',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              let data = backdata.data.data;
              this.dessertsLog = data.data;
              this.totallog = data.count;
              this.pagelog = data.pageSize;
          });
        },
        //定时器
        times(){
          let _this = this;
          let oen = 1;
          this.timer = setInterval(() => {
            _this.changelog(_this.pe);
            if(oen > 400){
              _this.emdtime();
            }
            oen++;
          }, 2000);
        },
        emdtime(){
          let _this = this;
          clearInterval(this.timer);
        },
        //战区
        zone(){
          this.$myhttp.get('admin/common/zone1',{
          'Content-Type': 'application/json'
          }).then(backdata=>{
          	if(backdata.data.code == 200) {
          	  this.options = backdata.data.data
          	} else {
              this.$message.error(backdata.data.message);
          	}
          });
        },
        zonec(data){
         this.getProjectList2();
        },
        // 获得自己名下的所有项目,战区
        getProjectList2() {
          this.addtype = 1;
          this.types = 1;
          this.$myhttp.get('admin/common/pindex2?projectId=' + this.jurisdictionId + "&zones=" + this.zones,{
            'Content-Type': 'application/json'
          }).then(backdata=>{
          	if(backdata.data.code == 200) {
              let tableData = backdata.data.data;
              this.$myhttp.post('admin/RoutineExpense/indexList',tableData,{
                'Content-Type': 'application/x-www-form-urlencoded'
                }).then(backdata=>{ // 异步执行成功后
                this.types = 2;
                if(backdata.data.code == 200) {
                  let data = backdata.data.data;
                  this.tableData = data;
                }else{
                  this.$message.error(backdata.data.message);
                }
              });
            } else {
              this.$message.error(backdata.data.message);
            }
          });
        },
        // 获得自己名下的所有项目
        getProjectList() {
          this.addtype = 1;
          this.types = 1;
          this.$myhttp.get('admin/common/pindex2?projectId=' + this.jurisdictionId,{
            'Content-Type': 'application/json'
          }).then(backdata=>{
          	if(backdata.data.code == 200) {
              let tableData = backdata.data.data;
              this.$myhttp.post('admin/RoutineExpense/indexList',tableData,{
                'Content-Type': 'application/x-www-form-urlencoded'
                }).then(backdata=>{ // 异步执行成功后
                this.types = 2;
                if(backdata.data.code == 200) {
                  let data = backdata.data.data;
                  this.tableData = data;
                }else{
                  this.$message.error(backdata.data.message);
                }
              });
            } else {
              this.$message.error(backdata.data.message);
            }
          });
        },
        handleSelectionChange(val) {
          this.orders = val;
        },
        handleSelectionChange1(val){

        },
        boots(e){
          let data = {'type':1,'boot':e,'data':this.tableData};
          this.$myhttp.post('admin/RoutineExpense/indexList',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            if(backdata.data.code == 200) {
              let data = backdata.data.data;
              this.tableData = data;
            }else{
              this.$message.error(backdata.data.message);
            }
          });
        },
        //提交
        listAdd(){
          this.types = 3;
          let data = {'orders':this.orders,'date':this.date};
          this.$myhttp.post('admin/RoutineExpense/calculateMoneyAddList',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
            this.types = 2;
            if(backdata.data.code == 200) {
              this.third();
            }else{
              this.$message.error(backdata.data.message);
            }
          });
        },
        handleClose(done) {
          done();
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/expense/RoutineExpenseLists.vue